<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-primary">
      <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#20A8D8"
        :is-full-page="false"
      />
    </base-header>

    <b-container fluid class="mt--7">
      <b-row>
        <b-col> // TODO </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// Others
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "members",
};
</script>

<style scoped></style>
